import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";
import AuthPanel from "@/components/AuthPanel";

export default function SignIn() {
  return (
    <div className="min-h-screen bg-ink text-hi flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-sm rounded-2xl border border-line bg-panel p-8"
        data-testid="signin-screen"
      >
        <Logo />
        <h1 className="font-display text-3xl font-black uppercase tracking-wide mt-6">Fleet command</h1>
        <p className="text-mid text-sm mt-1">Private garage. Sign in to continue.</p>
        <AuthPanel idPrefix="signin" />
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-mid hover:text-hi transition"
        >
          ← Back to the site
        </Link>
      </motion.div>
    </div>
  );
}
